<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <h3 class="text strat pt-3">Stock Transfer to Branch</h3>
    <form (ngSubmit)="saveTransferData()" [formGroup]="returnToBranchForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="fromBranchSelect">From Branch <span class="text-danger">*</span></label>
          <ng-select labelForId="fromBranchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [searchable]="true" placeholder="Select From Branch" formControlName="fromBranch"
            class="ng-select-bootstrap" appendTo="body">
          </ng-select>
          @if (
          returnToBranchForm.get("fromBranch")?.invalid &&
          (returnToBranchForm.get("fromBranch")?.dirty ||
          returnToBranchForm.get("fromBranch")?.touched)
          ) {
          <div class="errorText">
            @if (
            returnToBranchForm.get("fromBranch")?.errors?.["required"]
            ) {
            <div>
              <small class="text-danger">Select Branch Type</small>
            </div>
            }
          </div>
          }
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3">
          <label for="toBranchSelect">To Branch <span class="text-danger">*</span></label>
          <ng-select labelForId="toBranchSelect" [items]="filteredToBranchList" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [searchable]="true" placeholder="Select To Branch" formControlName="toBranch"
            class="ng-select-bootstrap" appendTo="body">
          </ng-select>
        </div>
      </div>
      @for (item of stock.controls; track item; let i = $index) {
      <div formArrayName="stock" class="stockArray">
        <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreSizeSelect_' + i">Tyre Size <span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSizeList[i].list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size" formControlName="tyreSize"
              class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (scrollToEnd)="onScrollTyreSize(i)" (search)="onTyreSizeInputChange($event, i)">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreMakeSelect_' + i">Tyre Make <span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreMakeSelect_' + i" [items]="tyreMakeList[i].list" [multiple]="false" [clearable]="true" [searchable]="true"
              placeholder="Search or Select Tyre Make" formControlName="tyreMake" class="ng-select-bootstrap"
              appendTo="body" [searchFn]="customSearchFn" (change)="selectMake($event, i)"
              (search)="onTyreMakeInputChange($event, i)">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
            <ng-select [labelForId]="'tyreModelSelect_' + i" [items]="tyreModelList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Model"
              formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="!stock.at(i).get('tyreMake')?.value" (change)="getFreightDetails(i)" (scrollToEnd)="scroll(i)"
              (search)="onTyreModelInputChange($event, i)">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'quantityInput_' + i">Total Quantity <span class="text-danger">*</span></label>
            <input [id]="'quantityInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="quantity"
              name="quantity" required placeholder="Eg: 10" appBlockNumberSpecialchars [extraChars]="['.']" [appMaxLength]="10" />
            @if (
            stock.at(i).get("quantity")?.invalid &&
            stock.at(i).get("quantity")?.touched
            ) {
            <div>
              @if (stock.at(i).get("quantity")?.errors?.['required']) {
                <small class="text-danger">Quantity is required</small>
              }
              @if (stock.at(i).get("quantity")?.errors?.['min']) {
                <small class="text-danger">Quantity must be at least 1</small>
              }
            </div>
            }
          </div>
          <div class="col-6 col-md-3">
            <div class="amount">
              <span class="fw-semibold text-muted">Min Amount</span>
              <p class="amount-value pt-2">
                {{ priceDetailsArray[i].minPrice || "-" }}
              </p>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="amount">
              <span class="fw-semibold text-muted">Max Amount</span>
              <p class="amount-value pt-2">
                {{ priceDetailsArray[i].maxPrice || "-" }}
              </p>
            </div>
          </div>
          <div class="col-6 col-md-3 text-center">
            <div class="amount">
              <span class="label fw-semibold text-muted">Average Amount</span>
              <p class="amount-value pt-2">
                {{ priceDetailsArray[i].avgPrice || "-" }}
              </p>
            </div>
          </div>
          <div class="col-6 col-md-3 d-flex align-items-end justify-content-start">
              @if (i == stock.length - 1) {
              <button class="btn app-btn-primary me-1" type="button" (click)="addItem(i)"
                [disabled]="transactionId">
                <fa-icon [icon]="faPlus" class="fa-1x"></fa-icon>
              </button>
              }
              @if (stock.length > 1) {
              <button class="btn btn-danger" type="button" (click)="removeItem(i)"
                [disabled]="transactionId">
                <fa-icon [icon]="faTrash" class="fa-1x"></fa-icon>
              </button>
              }
          </div>
        </div>
      </div>
      }

      @if (transactionId) {
      <div class="row pt-3 g-3">
        <div class="col-12 col-md-6">
          <label for="editReasonTextarea">Reason for Edit<span class="text-danger">*</span></label>
          <textarea id="editReasonTextarea" formControlName="editReason" rows="2" class="form-control default-form-group-border"
            placeholder="Please provide a reason for editing this transaction"></textarea>
          @if (
          returnToBranchForm.get("editReason")?.invalid &&
          returnToBranchForm.get("editReason")?.touched
          ) {
          <div>
            <small class="text-danger">Reason for edit is required</small>
          </div>
          }
        </div>
      </div>
      }

      <div class="row pt-3">
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/order-list'">
            Cancel
          </button>
          <button type="submit" [disabled]="returnToBranchForm.invalid" class="btn app-btn-primary">
            Submit
            @if (isLoading) {
             <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
        <div class="text-danger">{{ resMsg }}</div>
      </div>
    </form>
  </div>
</section>